import request from '../../request';

export default {
  namespaced: true,
  state: {
    data: {},
    relevantEntriesCount: 0,
  },
  mutations: {
    setList(state, transactions) {
      let relevantEntriesCount = 0;
      if (transactions.length > 0) {
        transactions.forEach((transaction) => {
          if (transaction.value - transaction.fee > 0) {
            relevantEntriesCount += 1;
          }
        });
      }
      Object.assign(state, { data: transactions });
      Object.assign(state, { relevantEntriesCount });
    },
  },
  actions: {
    list(context, payload) {
      return new Promise((resolve) => {
        const url = `${process.env.API_URL}transactions?include=occurrence`;
        request.make({
          type: 'GET',
          url,
          data: payload,
        }, (err, res) => {
          if (err === null) {
            context.commit('setList', res.body.data);
          } else {
            context.commit('setList', []);
          }
          resolve();
        });
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/promoter/transactions.js